import {createSearchParams, useParams} from 'react-router-dom'
import {getRequest} from '../../../services/base'
import {useContext, useEffect, useMemo, useRef, useState} from 'react'
import {NavContext} from '../../../context/global_context'
import {SalesCodeContext, SELECT_SALES_CODE, SET_SALES_CODE_LIST,} from './context/context'
import InputText from '../../common/InputText'
import SalesCodeTable from './SalesCodeTable'
import SalesCodeFormModal from './form'
import {getSessionStorageData} from '../../../utils/SessionStorage'
import {Flex, Form, Row, Space} from 'antd'
import useDebouncedValue from '../../../utils/common_function'
import {useIntl} from 'react-intl'
import { notifyError } from '../../../utils/notifications'

const SalesCodeList = () => {
  const intl = useIntl()
  let { vehicle } = useParams()

  const [state, dispatch] = useContext(SalesCodeContext)
  const [, navDispatch] = useContext(NavContext)

  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({})
  const currentUrl = useRef(`/api/sales_codes/?vehicle=${vehicle}`)

  const debouncedSearch = useDebouncedValue(search, 500)

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    getSalesCodeListData()

    navDispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({ id: 'layout.adminTools' }),
        sub_header:
          intl.formatMessage({ id: 'layout.vehicleList' }) +
          ` / ${vehicle} / ` +
          intl.formatMessage({ id: 'sidebar.salesCode' }),
        id: vehicle,
        show_back_btn: true,
        dtc_details: [],
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  useEffect(() => {
    currentUrl.current = `/api/sales_codes/?vehicle=${vehicle}&search=${search}`
    getSalesCodeListData()
  }, [debouncedSearch])

  const getSalesCodeListData = async (url) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'salesCodes.fetchingData' }),
        showLoader: true,
      },
      notification: {},
    })

    currentUrl.current = url ? url : currentUrl.current
    let res = await getRequest(currentUrl.current)
    setPagination(res.pagination)
    dispatch({ type: SET_SALES_CODE_LIST, data: res.results })

    navDispatch({
      type: 'loader',
      data: {
        showLoader: false,
      },
      notification: {},
    })

    // After the loader dispatch above: a 'loader' action overwrites `notification`,
    // so notifying before it would be wiped out in the same React batch.
    if (res?.status === false) {
      notifyError(navDispatch, intl.formatMessage({ id: 'salesCodes.loadError' }))
    }
  }

  const buildUrl = ({ vehicle, search, limit, offset }) => {
    const params = new URLSearchParams({
      vehicle,
      search,
      limit,
      offset,
    })
    return `/api/sales_codes/?${params.toString()}`
  }

  const onEdit = (record) => {
    dispatch({
      type: SELECT_SALES_CODE,
      data: { selected_sales_code: record, show_sales_code_popup: true },
    })
  }

  const dataSource = useMemo(() => {
    if (!state?.sales_code_list?.length) return []

    return state?.sales_code_list?.map((item, index) => ({
      ...item,
      key: `sales-code-${index}`,
      rowKey: `sales-code-${item.id}`,
      index: index,
      group_display: item.group?.name || '-',
      group_description_display: item.group?.description || '-',
    }))
  }, [state.sales_code_list])

  return (
    <>
      <div className="page sub-page">
        <Row className="body">
          <Form className="full-width">
            <Flex justify="space-between" className="full-width">
              <InputText
                name="search_sales_code"
                type="search"
                placeholder={intl.formatMessage({
                  id: 'salesCodes.searchPlaceholder',
                })}
                value={search}
                isRequired={false}
                wrapperClass="search-sales-code"
                onChange={(value) => {
                  setSearch(value)
                }}
              />

              <Space size="middle" align="center" />
            </Flex>
          </Form>

          <SalesCodeFormModal getSalesCodeListData={getSalesCodeListData} />

          <Flex style={{ width: '100%' }}>
            <SalesCodeTable
              dataSource={dataSource}
              pagination={pagination}
              getSalesCodeListData={getSalesCodeListData}
              onEdit={onEdit}
            />
          </Flex>
        </Row>
      </div>
    </>
  )
}

export default SalesCodeList
